import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './customCursor.css';

export default function CustomCursor() {
  const root = useRef(null);
  useLayoutEffect(() => {
    const media = gsap.matchMedia();
    media.add('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)', (context) => {
      const ring = root.current.querySelector('.custom-cursor__ring');
      const dot = root.current.querySelector('.custom-cursor__dot');
      const label = root.current.querySelector('.custom-cursor__label');
      gsap.set([ring, dot], { xPercent: -50, yPercent: -50, x: 0, y: 0 });
      const ringX = gsap.quickTo(ring, 'x', { duration: .23, ease: 'power3' });
      const ringY = gsap.quickTo(ring, 'y', { duration: .23, ease: 'power3' });
      const dotX = gsap.quickSetter(dot, 'x', 'px');
      const dotY = gsap.quickSetter(dot, 'y', 'px');
      let visible = false;
      let previous = null;
      context.add('move', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (!visible) {
          gsap.set([ring, dot], { x: event.clientX, y: event.clientY });
          gsap.set(root.current, { autoAlpha: 1 });
          document.documentElement.classList.add('has-custom-cursor');
          visible = true;
        }
        ringX(event.clientX); ringY(event.clientY); dotX(event.clientX); dotY(event.clientY);
        const interactive = event.target.closest('a, button, [data-cursor]');
        if (interactive === previous) return;
        previous = interactive;
        const disabled = interactive?.getAttribute('aria-disabled') === 'true';
        const card = interactive?.classList.contains('project-card__control') || interactive?.classList.contains('gallery-card__link');
        label.textContent = card ? 'EXPLORE' : '';
        gsap.to(ring, { width: card ? 82 : interactive && !disabled ? 54 : 34, height: card ? 82 : interactive && !disabled ? 54 : 34,
          backgroundColor: card ? 'rgba(191, 0, 255, .85)' : 'rgba(191, 0, 255, 0)', duration: .25, overwrite: 'auto' });
        gsap.to(dot, { opacity: card ? 0 : 1, duration: .15, overwrite: true });
      });
      const hide = () => {
        visible = false; gsap.set(root.current, { autoAlpha: 0 });
        document.documentElement.classList.remove('has-custom-cursor');
      };
      const leave = (event) => { if (!event.relatedTarget) hide(); };
      const key = (event) => { if (event.key === 'Tab') hide(); };
      window.addEventListener('pointermove', context.move, { passive: true });
      document.addEventListener('pointerout', leave);
      window.addEventListener('blur', hide);
      window.addEventListener('scroll', hide, { passive: true });
      document.addEventListener('keydown', key);
      return () => {
        window.removeEventListener('pointermove', context.move);
        document.removeEventListener('pointerout', leave);
        window.removeEventListener('blur', hide);
        window.removeEventListener('scroll', hide);
        document.removeEventListener('keydown', key);
        hide();
      };
    });
    return () => media.revert();
  }, []);
  return <div className="custom-cursor" ref={root} aria-hidden="true">
    <span className="custom-cursor__ring"><span className="custom-cursor__label" /></span>
    <span className="custom-cursor__dot" />
  </div>;
}
